const employeeTypeFilters = {
    ALL: 'ALL',
    TRAINEE: 'TRAINEE',
};

export default employeeTypeFilters;
